import { Box } from '@factorialco/deprecated-design-system'
import { F0Button as Button } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type Props = {
  onCancel: () => void
  onConfirm: () => void
}

const BulkFDContractsModal = ({ onCancel, onConfirm }: Props) => {
  return (
    <Modal
      title={i18n.t('employees.fd_contracts.bulk_modal.title')}
      description={i18n.t('employees.fd_contracts.bulk_modal.description')}
      illustration="document-edit"
      onClose={onCancel}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button variant="outline" size="md" label={i18n.t('common.cancel')} onClick={onCancel} />
          <Button
            size="md"
            label={i18n.t('common.continue')}
            onClick={() => {
              onConfirm()
            }}
          />
        </Box>
      }
    />
  )
}

export default BulkFDContractsModal
